import { IArgumentPersonalNote } from "api/types/argumentPersonalNotes"

export const findArgumentPersonalNote = (
  argumentPersonalNotes: IArgumentPersonalNote[],
  argumentId: string
) =>
  argumentPersonalNotes.find(
    (argumentPersonalNote) => argumentPersonalNote.argumentId === argumentId
  )
